export default __webpack_public_path__ + "static/media/Armbands of Pandemonium.a8c95ab7.jpg";